<template>
  <h1>Test: Waage</h1>
  <div class="row">
    <div class="col-8 mb-3">
      Typ: {{ scaleBbType }}<br/>
      Host: {{ scaleBbHost }}
    </div>
  </div>

  <button @click="checkConnection" class="mt-3 mb-3" type="button">Verbindungstest</button>
  <button @click="getWeight" class="mt-3 mb-3" type="button">Abfrage: Gewicht</button>

  <div class="row">
    <div class="col-8">{{ resultOutput }}</div>
  </div>

  <app-btn-back class="pt-2"/>
</template>

<script>
import CryptoJS from 'crypto-js';
import axios from "axios";

export default {
  name: "TestScale",
  components: {
  },
  data() {
    return {
      resultOutput: '',
      token: ''
    }
  },
  created() {
    this.createToken();
  },
  computed: {
    scaleBbHost() {
      return this.$store.getters.scaleBbHost
    },
    scaleBbType() {
      return this.$store.getters.scaleBbType
    },
  },
  methods: {
    async checkConnection() {
      this.resultOutput = 'Verbinde. Warte auf Antwort...'
      try {
        const response = await axios.get(this.scaleBbHost +'/api/test', {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });

        this.resultOutput = response.data; // Handle response data
      } catch (error) {
        this.resultOutput = `Error: ${error.message}`; // Handle error
      }
    },
    async getWeight() {
      this.resultOutput =  'Verbinde. Warte auf Antwort...'
      let response = null
      let logMessage = ''

      try {
        response = await axios.get(this.scaleBbHost +'/api/'+ this.scaleBbType +'/send-weighing-cmd', {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });

        this.resultOutput = '';

        // handle response data
        logMessage = JSON.stringify(response.data);

        const weightResult = await this.getWeightFromScale(response);
        this.resultOutput += weightResult;

        logMessage += "\n\nresult: "+ weightResult;

      } catch (error) {
        this.resultOutput = `Error: ${error.message}`; // Handle error

        logMessage = JSON.stringify(error.response.data) +"\n\n"+ JSON.stringify(error);
      }

      await this.$store.dispatch('sendEmailMessage', {
        type: 'notifySupport',
        data: {
          subject: this.resultOutput,
          body: this.resultOutput +"\n\n"+ logMessage
        }
      })
    },
    createToken()
    {
      const header = {
        alg: "HS256",
        typ: "JWT"
      };

      const payload = {
        data: "examplePayload",
        exp: Math.floor(Date.now() / 1000) + (60 * 60) // Token expires in 1 hour
      };

      const secret = process.env.VUE_APP_PS_CONNECTOR_JWT_SECRET;

      // Base64URL encoding function
      const base64UrlEncode = (obj) => {
        // Regular base64 encoding
        const str = btoa(JSON.stringify(obj));
        // Convert to base64url format
        return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      };

      const headerEncoded = base64UrlEncode(header);
      const payloadEncoded = base64UrlEncode(payload);

      // Create the signature using crypto-js
      const signatureInput = `${headerEncoded}.${payloadEncoded}`;
      const signatureWordArray = CryptoJS.HmacSHA256(signatureInput, secret);

      // Convert the signature to base64 and then to base64url
      let signatureBase64 = CryptoJS.enc.Base64.stringify(signatureWordArray);
      const signatureBase64Url = signatureBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

      this.token = `${headerEncoded}.${payloadEncoded}.${signatureBase64Url}`;
    },
    async getWeightFromScale(response) {
      let result = null;
      try {
        result = response.data; // Handle response data
        let responseData = typeof response.data === 'object' ? response.data : JSON.parse(response.data);

        console.log('responseData', responseData.response);

        // manuell:
        // response = "{\"response\":\"<000002.06.2614:08   01    1560       0    1560kg   001   39670>\\r\\n\"}";
        // let responseData = JSON.parse(response);

        result = 'Antwort vom Waage: '+ responseData.response +' | ';

        // clear multiple spaces into single space
        responseData.response = responseData.response.replaceAll('       ', '*');
        responseData.response = responseData.response.replaceAll('      ', '*');
        responseData.response = responseData.response.replaceAll('     ', '*');
        responseData.response = responseData.response.replaceAll('    ', '*');
        responseData.response = responseData.response.replaceAll('   ', '*');
        responseData.response = responseData.response.replaceAll('  ', '*');
        responseData.response = responseData.response.replaceAll(' ', '*');

        const parts = responseData.response.split('*');
        result += 'Brutto: '+ parts[2] +' | ';
        result += 'Tara: '+ parts[3] +' | ';
        result += 'Netto: '+ parts[4] +' | ';

        console.log('responseData.response', responseData.response);

        // logMessage = JSON.stringify(response.data);
      } catch (error) {
        result = `Error: ${error.message}`; // Handle error

        // logMessage = JSON.stringify(error.response.data) +"\n\n"+ JSON.stringify(error);
      }
      return result;
    },
  }
}
</script>

<style scoped>

</style>